<template>
    <div>
        <h2>User details</h2>

        <h3>Profile</h3>
        <table class="table">
            <thead>
                <tr>
                    <th>Property</th>
                    <th>Value</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>ID</td>
                    <td>{{ user.id }}</td>
                </tr>
                <tr>
                    <td>User ID</td>
                    <td>{{ user.userId }}</td>
                </tr>
                <tr>
                    <td>Name</td>
                    <td>{{ user.name }}</td>
                </tr>
                <tr>
                    <td>E-mail</td>
                    <td>{{ user.email }}</td>
                </tr>
                <tr>
                    <td>Occupation</td>
                    <td>{{ user.occupation }}</td>
                </tr>
                <tr>
                    <td>Platform</td>
                    <td>{{ user.platform }}</td>
                </tr>
                <tr>
                    <td>Created</td>
                    <td>{{ user.createdAt }}</td>
                </tr>
                <tr>
                    <td>Last played</td>
                    <td>{{ user.lastPlayed }}</td>
                </tr>
                <tr>
                    <td>Last shuffled</td>
                    <td>{{ user.lastShuffled }}</td>
                </tr>
                <tr>
                    <td>Shuffle seed</td>
                    <td>{{ user.seed }}</td>
                </tr>
                <tr>
                    <td>Known language</td>
                    <td>{{ user.locale }}</td>
                </tr>
                <tr>
                    <td>Approved terms</td>
                    <td>{{ user.approvedTerms }}</td>
                </tr>
                <tr>
                    <td>Marketing opt-in</td>
                    <td>{{ user.marketingOptIn }}</td>
                </tr>
                <tr>
                    <td>Delete requested</td>
                    <td><span v-if="user.deleteRequested" class="deleteRequested">DELETE REQUESTED</span></td>
                </tr>
                <tr>
                    <td>Subscription type</td>
                    <td>{{ user.subscriptionType }}</td>
                </tr>
                <tr>
                    <td>Gift claimed at</td>
                    <td>{{ formatDate(user.giftClaimedAt) }}</td>
                </tr>
                <tr>
                    <td>Gift expires at</td>
                    <td>{{ formatDate(user.giftExpiresAt) }}</td>
                </tr>
                <tr>
                    <td>Shopify customer e-mail</td>
                    <td>{{ user.shopifyCustomerEmail }}</td>
                </tr>
                <tr>
                    <td>Answered</td>
                    <td>{{ user.countAnswers }}</td>
                </tr>
            </tbody>
        </table>

        <h3>Active Vouchers / Shopify Codes</h3>
        <table class="table">
            <thead>
                <tr>
                    <th>ID</th>
                    <th>Code</th>
                    <th>Subscription type</th>
                    <th>Duration (days)</th>
                    <th>Created at</th>
                    <th>Created by</th>
                    <th>Claimed at</th>
                    <th>Expires at</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="voucher in vouchers" :key="voucher.id">
                    <td>{{ voucher.id }}</td>
                    <td>{{ voucher.code }}</td>
                    <td>{{ voucher.subscriptionType }}</td>
                    <td>{{ voucher.durationDays }}</td>
                    <td>{{ formatDate(voucher.createdAt) }}</td>
                    <td>{{ voucher.createdBy }}</td>
                    <td>{{ formatDate(voucher.claimedAt) }}</td>
                    <td>{{ formatDate(voucher.expiresAt) }}</td>
                </tr>
            </tbody>
        </table>

        <h3>Subscriptions</h3>
        <table class="table">
        <thead>
            <tr>
            <th>Source</th>
            <th>Status</th>
            <th>Entitlements</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="subscription in subscriptions" :key="subscription.id">
            <td>{{ subscription.source }}</td>
            <td>{{ subscription.status }}</td>
            <td>{{ subscription.entitlements ? subscription.entitlements.join(', ') : 'N/A' }}</td>
            </tr>
        </tbody>
        </table>
    </div>
</template>

<script>
import { fetchUser, fetchUserVouchers, fetchUserSubscriptions } from '@/repository/apiService';

export default {
    data() {
        return {
            userId: null,
            user: {},
            vouchers: [],
            subscriptions: []
        };
    },
    created() {
        this.refresh();
    },
    watch: {
        '$route.params.id': {
            immediate: true,
            handler(newVal) {
                this.userId = newVal;
                this.refresh();
            }
        }
    },
    methods: {
        async refresh() {
            try {
                this.user = await fetchUser(this.userId);
                if (this.user.platform == "deletion_requested") {
                    this.user.deleteRequested = true;
                }
                this.vouchers = await fetchUserVouchers(this.userId);
                this.subscriptions = await fetchUserSubscriptions(this.userId);
            } catch (error) {
                // Handle errors, e.g., show an error message
            }
        },
        formatDate(date) {
            if (date) {
                return (new Date(date)).toLocaleString();
            }
            return '';
        }
    }
};
</script>

<style>
.deleteRequested {
    font-weight: bold;
    color: red;
}
</style>
